import React from 'react';
import {Button, Container, Header} from "semantic-ui-react";
import momentLocalizer from "react-widgets-moment";
import moment from "moment/moment";
import Config from 'Config';
import {dbGet} from "../../utils/ajaxUtils";

class MaintenancePage extends React.Component {
    constructor(props) {
        super(props);
        moment.locale('en');
        momentLocalizer();

    }

    render() {
        return (
            <Container textAlign='center' className='publish-log-page'>
                <Header as='h1'>Beaker Maintenance</Header>
                
                <Button className='primary'
                        size='massive'
                        onClick={this.flushCache}>
                    Clear Cache
                </Button>

                <Button className='primary'
                        size='massive'
                        onClick={this.reindex}>
                    Reindex
                </Button>
            </Container>
        )
    }

    reindex() {
        dbGet(`reindex`, {}).subscribe((response) => {
            console.log("ElasticSearch reindexed")
        });
    };

    flushCache() {
        dbGet(`flushcache`, {}).subscribe((response) => {
            console.log("Flushed Cache")
        });
    };
}

export default MaintenancePage;


// WEBPACK FOOTER //
// ./public/pages/Maintenance/MaintenancePage.jsx